import { useBaseRootActions } from '../../baseRoot.actions';
import { buAtom } from './BuState';

function useBuActions() {
  const baseActions = useBaseRootActions('bu', buAtom);

  return {
    list: baseActions.list,
    get: baseActions.get,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  };
}

export { useBuActions };
